// extracted by mini-css-extract-plugin
export default {"box":"MessageGrid_box__xjiq1","btn":"MessageGrid_btn__4l3nH","time":"MessageGrid_time__ooK4E"};